import axios from "axios"

const AdminToken = `Bearer ` + localStorage.getItem("rh_Admin_Token")

export let AxiosClone = axios.create({
    headers: {
        Authorization: AdminToken,
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Access-Control-Allow-Origin": "*",
    },
    timeout: 10000, // 10 second timeout
})
